import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { graphqlSdk } from "shared/graphql/client";
import { sleep } from "shared/utils/sleep";

import { HolderCommitmentParams } from "./types";

type Provider =
  | "twitter"
  | "uniswap"
  | "binance"
  | "telegram"
  | "instagram"
  | "discord";

type Params = { provider: Provider } & HolderCommitmentParams;

export const useCreateZKCertMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    { certificate: string | null; progress: number },
    TError,
    Params,
    TContext
  >
) => {
  const mutation = useMutation({
    mutationFn: async ({
      encryptionPubKey,
      holderCommitment,
      provider,
    }: Params) => {
      const params = { encryptionPubKey, holderCommitment };
      if (provider === "uniswap") {
        const data = await graphqlSdk.CreateUniswapZKCertificate({
          in: params,
        });

        const { certificate, progress } = data.createUniswapZKCertificate;
        return { certificate, progress };
      }

      if (provider === "binance") {
        const data = await graphqlSdk.CreateBinanceZKCertificate({
          in: params,
        });

        const { certificate, progress } = data.createBinanceZKCertificate;
        return { certificate, progress };
      }

      const data = await graphqlSdk.CreateTwitterZKCertificate({
        in: params,
      });

      console.log("useCreateZKCertMutation", data);

      const { certificate, progress } = data.createTwitterZKCertificate;
      if (certificate) await sleep(10000);
      return { certificate, progress };
    },

    ...options,
  });

  return mutation;
};
